export enum LayoutType {
  Mobile = 'mobile',
  Desktop = 'desktop',
}

export type PageLayout = {
  type: LayoutType;
};

export type GetLayout = () => PageLayout;
